/**
 * Action for wordpress/posts module
 */
import wpAPI from '@/api/wordpress'
import {errorHandler} from '@/helpers'
import types from './types'

const actions = {
  /**
   * 投稿一覧の取得
   */
  async [types.FETCH] ({ dispatch, commit, getters, rootGetters }) {
    return wpAPI.getPosts().then(res => {
      commit(types.FETCH, res.data)
      return res.data
    }).catch(errorHandler)
  },

  /**
   * 新規投稿の作成
   */
  async [types.CREATE] ({ dispatch, commit, getters, rootGetters }, post) {
    return wpAPI.createPost({
      date: post.date,
      slug: post.slug,
      status: post.status,
      title: post.title,
      content: post.html,
      author: rootGetters['wordpress/account/id'],
      featured_media: post.featured_media,
      css: post.css,
      header: post.header,
      extensions: post.extensions,
      components: post.components
    }).then(res => {
      commit(types.CREATE, res.data)
      return res.data
    }).catch(errorHandler)
  },

  /**
   * 投稿の更新
   */
  async [types.UPDATE] ({ dispatch, commit, getters, rootGetters }, post) {
    /**
     * 一度非公開にするとページタイトルに『非公開: 』という文字が追加される。
     * ここでは post.status が private 以外かつタイトルの頭に『非公開: 』がつく場合は
     * 『非公開: 』をタイトルから削除する
     */
    if (post.status !== 'private' && post.title.rendered.startsWith('非公開: ')) post.title.rendered = post.title.rendered.replace(/非公開: /, '')
    return wpAPI.updatePost(post.id, {
      date: post.date,
      slug: post.slug,
      status: post.status,
      title: post.title.rendered,
      content: post.html,
      featured_media: post.featured_media,
      css: post.css,
      header: post.header,
      extensions: post.extensions,
      components: post.components
    }).then(res => {
      commit(types.UPDATE, res.data)
      return res.data
    }).catch(errorHandler)
  },

  /**
   * 投稿の削除
   */
  async [types.DELETE] ({ dispatch, commit, getters, rootGetters }, id) {
    return wpAPI.deletePost(id).then(res => {
      commit(types.DELETE, res.data.previous)
      return res.data.previous
    }).catch(errorHandler)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/posts/actions.js